import {Modal} from "react-bootstrap";
import {forwardRef, useImperativeHandle, useState} from "react";
import {LoginHome} from "../../users";

export type ModalApi = {
    open: () => void;
    close: () => void;
}

const LoginFormView = forwardRef<ModalApi, any>((props, ref) => {
    const [show, setShow] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setShow(true),
        close: () => setShow(false),
    }));

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} centered={true} className="custom-modal">
            <LoginHome onClose={handleClose}/>
        </Modal>
    );
});

export default LoginFormView;
